<template>
  <v-card
    flat
  >
    <v-card-text>
      <v-row class="mt-10 align-center ">
        <v-col cols="12">
          <h1 class="text-center text-md-h2 text-sm-h3 text-xs-h3 font-weight-bold">
            Seja muito bem-vindo(a)!
          </h1>
        </v-col>

        <v-col
          cols="12"
          class="mt-16"
        >
          <div class="d-flex justify-space-between">
            <v-btn
              color="secondary"
              outlined
              @click="sair"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="handleStepValidation"
            >
              Avançar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { useRouter } from '@core/utils'
import { clearStores } from '@/utils/store'

export default {
  setup(_, { emit }) {
    const { router } = useRouter()

    function sair() {
      clearStores()
      router.push({ name: 'auth-login' })
    }
    function handleStepValidation() {
      emit('handleStepValidation')
    }

    return {
      sair,
      handleStepValidation,
    }
  },
}
</script>
